import { useEffect, useState } from "react";
import "../App.css";
import { toast, Bounce } from "react-toastify";
import { API } from "../assets/staticData";

// Parses the JSON returned by a network request
const parseJSON = (resp) => (resp.json ? resp.json() : resp);

// Checks if a network request came back fine, and throws an error if not
const checkStatus = (resp) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp) => {
    throw resp;
  });
};

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer 1a9c05291159a654321d1a23bbae4303f0fe1765ed22ef487c75f78c02ae3255dbe99ae52a3daeaad0b84c39cd7582d01a61c7998d1b12be6e17eb5f29bccc26e02a23a9866682fdec86baaccb480ca7a37fc536c496f83d558ad711948a5f833b92c4a5cc9a39fd1205dbe1e6ad03eb6a89952b5b3b6e75433cffe115e911f9`,
};

const Registration = () => {
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    slogan: "",
    attractiveAccount: "",
    registrationLink: "",
  });

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const upload = () => {
    if (data.slogan !== "" && data.attractiveAccount !== "" && data.registrationLink !== "") {
      fetch(`${API}/registrations`, {
        headers,
        method: "POST",
        body: JSON.stringify({
          data: {
            slogan: data.slogan,
            attractiveAccount: data.attractiveAccount,
            registrationLink: data.registrationLink,
          },
        }),
      })
        .then(() => {
          setData({
            slogan: "",
            attractiveAccount: "",
            registrationLink: "",
          });
          toast("The changes were successfully added", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h2>Quick Registration Section</h2>
        <div className="input-fields">
          <input
            type="text"
            placeholder="Slogan"
            value={data.slogan}
            onChange={(e) => handleBannerDataChange("slogan", e.target.value)}
          />
          <input
            type="text"
            placeholder="Attractive Account"
            value={data.attractiveAccount}
            onChange={(e) =>
              handleBannerDataChange("attractiveAccount", e.target.value)
            }
          />
          <input
            type="text"
            placeholder="Registration Link"
            value={data.registrationLink}
            onChange={(e) =>
              handleBannerDataChange("registrationLink", e.target.value)
            }
          />
        </div>

        <button onClick={upload}>Add Registration</button>
      </div>
    </div>
  );
};

export default Registration;
